module.exports = __webpack_public_path__ + "static/media/logo-thumb-white.144844a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-thumb-white.svg
// module id = 593
// module chunks = 1